module.exports = __webpack_public_path__ + "b8e1bd78aadd40d56fc7cdb9582f6b39.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-14.png
// module id = 1696
// module chunks = 0